import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import Alert from 'reactstrap/lib/Alert';
import { Link } from 'react-router-dom';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';

import { receiveProducts } from '@ttstr/actions';
import { AppState } from '@ttstr/reducers';
import { useActions, useShallowEqualSelector } from '@ttstr/utils';
import { Container, LoadingSpinner, Masonry, useIntl, ContentrArea } from '@ttstr/components';

const ProductListing: React.FC = () => {
  const { t } = useTranslation();
  const { loading, products } = useShallowEqualSelector(mapStateToProps);
  const { receiveProducts } = useActions(mapDispatchToProps);
  const { language } = useIntl();

  React.useEffect(() => {
    receiveProducts();
  }, [language]);

  return (
    <article className="product-listing list-page mb-5">
      <Helmet>
        <title>{t(`PRODUCTS.TITLE`)}</title>
        <body className="product-listing-page" />
      </Helmet>

      <div className="hero-image d-flex justify-content-center">
        <Container className="h-100 d-flex justify-content-center align-items-center">
          <img
            src={require('./assets/images/so_main_orange.png')}
            alt="Felix Lobrecht – SELL OUT"
            title="Felix Lobrecht – SELL OUT"
            className="hero-image-overlay"
            loading="lazy"
          />
        </Container>
      </div>

      <Container>
        <ContentrArea id="before-listing" />
        {/* <h1 className="text-center mb-4">{t(`PRODUCTS.TITLE`)}</h1> */}
      </Container>

      <Container className="listing-filter-buttons-container">
        <Row className="mb-3 mt-5 d-flex align-items-center justify-content-center listing-buttons-container">
          <Col sm="12" md="12" lg="12" className="mt-2">
            <Link
              to="/products"
              className="btn btn-lg btn-primary btn-tickets h-100 mr-2 mb-2"
              onClick={() => {
                const element = document.getElementById('listing');
                if (!element) return;
                window.scroll({
                  top: element.offsetTop - 100,
                  behavior: 'smooth',
                });
              }}
            >
              Alle Artikel
            </Link>
            {/* <Col sm="12" md="6" lg="3" className="mt-3">
              <Link 
                to="/tickets?tagId=8179"  
                className="btn btn-lg btn-primary btn-tickets h-100"
                onClick={() => {
                  const element = document.getElementById('listing');
                  if ( !element ) return;
                  window.scroll({
                    top: element.offsetTop - 100,
                    behavior: 'smooth'
                  }) 
                }}  
              >                
                Tryouts
              </Link>
            </Col> */}
            <Link
              to="/products?categoryId=668"
              className="btn btn-lg btn-primary btn-tickets h-100  mr-2 mb-2"
              onClick={() => {
                const element = document.getElementById('listing');
                if (!element) return;
                window.scroll({
                  top: element.offsetTop - 100,
                  behavior: 'smooth',
                });
              }}
            >
              T-Shirts
            </Link>
            <Link
              to="/products?categoryId=1689"
              className="btn btn-lg btn-primary btn-tickets h-100  mr-2 mb-2"
              onClick={() => {
                const element = document.getElementById('listing');
                if (!element) return;
                window.scroll({
                  top: element.offsetTop - 100,
                  behavior: 'smooth',
                });
              }}
            >
              Pullover
            </Link>
            <Link
              to="/products?categoryId=667"
              className="btn btn-lg btn-primary btn-tickets h-100  mr-2 mb-2"
              onClick={() => {
                const element = document.getElementById('listing');
                if (!element) return;
                window.scroll({
                  top: element.offsetTop - 100,
                  behavior: 'smooth',
                });
              }}
            >
              Kram
            </Link>
          </Col>
        </Row>
      </Container>

      <Container className="pt-3">
        {loading ? ( // if loading
          <LoadingSpinner label={t(`LOADING.PRODUCTS`)} />
        ) : products.length === 0 ? ( // if no products
          <Alert color="info">{t(`MASONRY.NO_ITEMS`)}</Alert>
        ) : (
          // else show products
          <Masonry id="product-listing" products={products} filters="off" itemClassName="mb-4" showSubtitle showTags />
        )}
      </Container>

      <Container>
        <ContentrArea id="after-listing" />
      </Container>
    </article>
  );
};

const mapStateToProps = (state: AppState) => {
  const { products, loading } = state.Products;
  return {
    products,
    loading,
  };
};

const mapDispatchToProps = {
  receiveProducts,
};

export default React.memo(ProductListing);
